export const processContent = [
  "Cadastro: Informe seus dados através do formulário desta página.",
  "Análise: Nosso time avaliará os seus dados e entrará em contato através do WhatsApp ou e-mail.",
  "Reunião: Marcaremos uma conversa para te apresentar a GUD, nossos diferenciais, os benefícios do Mercado Livre de Energia  e como funciona nosso programa de parceiros.",
  "Formalização: Assinatura do contrato, oficializando o início da parceria.",
  "Treinamento: Conte com nossos especialistas para aprender sobre o mercado livre de energia.",
];
